import { useEffect, useRef, useState } from "react";
import "./DatepickerModal.css";
import DatePicker from "../datePicker/DatePicker";
import { useSelector } from 'react-redux';
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import dayjs from "dayjs";

const DatePickerModalComponent = (props) => {

    const { modalOpen, onClose, onClear, onSave, type, todoTitle, date } = props;
    const ref = useRef();
    const [saveButtonText, setSaveButtonText] = useState('');
    const [titleText, setTitleText] = useState('');
   

    const handleClose = () => {
        onClose();
        ref.current?.close();
    };

    const handleSaveDate = () => {
            onSave();
        ref.current?.close();
    };

    const handleClear = () => {
        onClear();
        ref.current?.close();
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleClear();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (modalOpen) {
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }

        switch (type) {
            case "dueDate":
                setTitleText(`Add a due date`)
                setSaveButtonText('Add due date')
                break;
            case "notification":
                setTitleText(`Add a notification date`)
                setSaveButtonText('Add notification')
                break;
            case "hidden":
                setTitleText(`Hide ${(todoTitle ? todoTitle : '')} `)
                setSaveButtonText('Hide')
                break;
            default:
                setTitleText('')
                setSaveButtonText('Save')
                break;
        }

    }, [modalOpen]);

    return (
        <dialog className="gt-modal" aria-labelledby="datetimepicker" ref={ref} >
            <div className="gt-modal-content">
                <div className="gt-modal-content__heading">
                    <h2 id="smartAssistant">{titleText}</h2>
                    <button className="gw-icon-button gw-icon-button--icon" aria-label="close date picker"
                        onClick={() => { handleClose() }}
                    >
                        <i className="gw-icon-button__icon gw-button__icon--close"></i>
                    </button>
                </div>
                <div className="gt-modal-content__body">
                    <DatePicker

                        date={date}
                        datePickerType={type} />
                    <div style={{ display: "flex", justifyContent: "space-evenly"}}>
                        {date && (
                            <button className="gw-button gw-button--secondary"
                                onClick={() => { handleClear() }}
                            >Clear</button>
                        )}
                        <button className="gw-button gw-button--primary"
                            onClick={() => { handleSaveDate() }}
                        >{saveButtonText}</button>
                    </div>
                </div>

            </div>
        </dialog>
    );
};

export default DatePickerModalComponent;